import React, { useState, useEffect, useRef } from 'react';

// A rendered formula is a deep tree of spans plus a MathML copy of itself.
// Typing through it would scramble the equation on screen, so each one is
// emitted whole. The custom wrappers never nest, so a non-greedy match is exact.
const MATH_BLOCK = /<chat-math\b[^>]*>[\s\S]*?<\/chat-math>|<chat-math-block\b[^>]*>[\s\S]*?<\/chat-math-block>/g;

// html tags and entities type as one chunk, plain text one character at a time
// <p>, </div>, &nbsp;, hello, world etc...
const pushProseSteps = (html, steps) => {
    (html.match(/<[^>]+>|&[^;]+;|[^<&]+/g) || []).forEach(token => {
        if (token.startsWith('<') || token.startsWith('&')) steps.push(token);
        else steps.push(...token.split(''));
    });
};

const buildSteps = (htmlContent) => {
    const steps = [];
    let lastIndex = 0;
    let match;
    MATH_BLOCK.lastIndex = 0;
    while ((match = MATH_BLOCK.exec(htmlContent)) !== null) {
        pushProseSteps(htmlContent.slice(lastIndex, match.index), steps);
        steps.push(match[0]);
        lastIndex = match.index + match[0].length;
    }
    pushProseSteps(htmlContent.slice(lastIndex), steps);
    return steps;
};

const HtmlTypewriter = ({ htmlContent, speed = 5 }) => {
    const [displayedContent, setDisplayedContent] = useState("");
    const intervalRef = useRef(null);

    useEffect(() => {
        const steps = buildSteps(htmlContent);

        let currentIndex = 0;
        setDisplayedContent(""); 
        
        intervalRef.current = setInterval(() => {
            if (currentIndex >= steps.length) {
                clearInterval(intervalRef.current);
                return;
            }
            
            setDisplayedContent(prev => prev + steps[currentIndex]);
            currentIndex++;
        }, speed);
        
        return () => clearInterval(intervalRef.current);
    }, [htmlContent, speed]);

    return <div dir='auto' dangerouslySetInnerHTML={{ __html: displayedContent }} />;
};

export default HtmlTypewriter;
